import {FlexBox} from '@esgi/ui/layout';

export function AddSelfAssessCard() {
	return <FlexBox>
			<img alt='add self assess' src='https://esgiwebfiles.s3.amazonaws.com/assignments-introduction/add-self-assess-tests.png' width='213'/>
		</FlexBox>;
}